import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  flightScheduleData: [],
  flightScheduleBookingData: [],
  isLoading: false,
  hasData: false,
  error: "",
  isEdit: false,
  redemptionToggle: false
};
const flightScheduleSlice = createSlice({
  name: "flightSchedule",
  initialState,
  reducers: {
    flightScheduleRequest: state => {
      state.isLoading = true;
    },
    flightScheduleSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.flightScheduleData = action.payload;
    },
    flightScheduleFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    saveFlightScheduleBookingData: (state, action) => {
      state.flightScheduleBookingData = action.payload;
    },
    editSearchFlights: (state, action) => {
      state.isEdit = action.payload;
    },
    flightScheduleRedemptionAction: (state, action) => {
      state.redemptionToggle = action.payload;
    },
    flightScheduleReset: state => {
      state.isLoading = false;
      state.error = "";
      state.hasData = false;
      state.flightScheduleData = [];
      state.flightScheduleBookingData = [];
      state.isEdit = false;
      state.redemptionToggle = false;
    }
  }
});
export const {
  flightScheduleRequest,
  flightScheduleSuccess,
  flightScheduleFailure,
  saveFlightScheduleBookingData,
  editSearchFlights,
  flightScheduleReset,
  flightScheduleRedemptionAction
} = flightScheduleSlice.actions;
export default flightScheduleSlice.reducer;